import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getManagerBoards } from '../../../api/managerBoardApi';

function PostRow({ post, navigate, currentPage, keyword }) {
  return (
    <tr
      style={{ cursor: 'pointer' }}
      onClick={() => navigate(`/manager/board/${post.id}?page=${currentPage}&search=${encodeURIComponent(keyword || '')}`)}
    >
      <td>
        <h5 className="font-size-14 mb-0 d-inline">{post.title}</h5>
      </td>
      <td className="text-center">{post.writer_id || '-'}</td>
      <td className="text-center text-muted">
        {post.created_at ? new Date(post.created_at).toLocaleString() : '-'}
      </td>
    </tr>
  );
}

function BoardList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [total, setTotal] = useState(0);

  const limit = 10;
  const currentPage = parseInt(searchParams.get('page') || '1', 10);
  const keyword = searchParams.get('search') || '';
  const totalPages = Math.max(1, Math.ceil(total / limit));

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getManagerBoards({ page: currentPage, limit, search: keyword });
      setRows(Array.isArray(data?.posts) ? data.posts : []);
      setTotal(Number(data?.total || 0));
    } catch (err) {
      console.error('관리자 게시글 목록 조회 실패:', err);
      alert('관리자 게시글 목록 조회 실패');
    } finally {
      setLoading(false);
    }
  }, [currentPage, keyword]);

  useEffect(() => {
    setSearchTerm(keyword);
    loadData();
  }, [keyword, loadData]);

  const handleSearch = (e) => {
    e.preventDefault();
    const nextKeyword = searchTerm.trim();
    navigate(`/manager/board?page=1&search=${encodeURIComponent(nextKeyword)}`);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">게시판 목록</h4>
            <button className="btn btn-primary" onClick={() => navigate('/manager/board/new')}>
              새 글 작성
            </button>
          </div>

          <form className="row g-2 mb-3" onSubmit={handleSearch}>
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="제목/내용/작성자 검색"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-auto">
              <button className="btn btn-outline-secondary" type="submit">
                검색
              </button>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-outline-danger"
                type="button"
                onClick={() => {
                  setSearchTerm('');
                  navigate('/manager/board?page=1&search=');
                }}
              >
                초기화
              </button>
            </div>
          </form>

          {loading ? (
            <div className="text-center text-muted mt-5">
              <div className="spinner-border text-secondary mb-3" role="status" />
              <p>불러오는 중...</p>
            </div>
          ) : rows.length === 0 ? (
            <div className="text-center text-muted mt-5">
              <p>게시글이 없습니다.</p>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-nowrap align-middle table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '50%' }}>제목</th>
                      <th className="text-center" style={{ width: '20%' }}>
                        작성자
                      </th>
                      <th className="text-center" style={{ width: '20%' }}>
                        작성일
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((post) => (
                      <PostRow
                        key={post.id}
                        post={post}
                        navigate={navigate}
                        currentPage={currentPage}
                        keyword={keyword}

                      />
                    ))}
                  </tbody>
                </table>
              </div>

              <nav className="mt-4">
                <ul className="pagination justify-content-center">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i + 1}
                      className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          navigate(
                            `/manager/board?page=${i + 1}&search=${encodeURIComponent(searchTerm)}`
                          )
                        }
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default BoardList;
